import WTF from '@zuul/wtf/native';
import Schema from './schema';
import Axios from 'axios';
import forEach from 'lodash/forEach';
import template from 'lodash/template';
import tpl from './thankyou.html';

export default class Connect {
    constructor({el}) {
        this.el = el;
        this.schema = new Schema();
        this.schema.data.actions.onSave = data => {
            this.onSuccess(data);
        };

        new WTF({ // eslint-disable-line no-new
            el,
            schema: this.schema.data
        });

        this.open = false;
    }

    bind() {
        const overlay = document.querySelector('.overlay');

        document.querySelector('.overlay .close').addEventListener('click', evt => {
            evt.preventDefault();

            overlay.parentNode.removeChild(overlay);
        });

        document.body.addEventListener('keyup', evt => {
            if (evt.keyCode === 27 && this.open) {
                this.open = false;

                overlay.parentNode.removeChild(overlay);

                this.el.innerHTML = '';

                new WTF({ // eslint-disable-line no-new
                    el: this.el,
                    schema: this.schema.data
                });

                document.body.removeEventListener('keyup');
            }
        });
    }

    renderThankYou() {
        const ctpl = template(tpl);
        const node = document.createElement('div');

        node.id = 'thank-you';
        node.classList.add('overlay');
        node.innerHTML = ctpl();

        document.body.appendChild(node);

        this.open = true;
        this.bind();
    }

    async onSuccess(ugc) {
        try {
            const payload = new FormData();
            const formData = {
                ...{action: 'new_lead'},
                ...ugc
            };

            forEach(formData, (val, key) => {
                payload.append(key, val);
            });

            const {status} = await Axios.post(`${window.endpointBase}`, payload);

            if (status === 200) {
                this.renderThankYou();
            }
        } catch (e) {
            console.log(e);
        }
    }
}
